import {
  SET_TRATAMIENTO,
  SET_SEXO,
  SET_NOMBRE_COMPRAMOS_TU_AUTO,
  SET_APELLIDO_PATERNO_COMPRAMOS_TU_AUTO,
  SET_ESTADO_COMPRAMOS_TU_AUTO,
  SET_CIUDAD_COMPRAMOS_TU_AUTO,
  SET_ID_CONCESIONARIO_COMPRAMOS_TU_AUTO,
  SET_CONCESIONARIO_COMPRAMOS_TU_AUTO,
  SET_TELEFONO_COMPRAMOS_TU_AUTO,
  SET_MOVIL_COMPRAMOS_TU_AUTO,
  SET_CORREO_COMPRAMOS_TU_AUTO,
  SET_ANO_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
  SET_MODELO_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
  SET_COLOR_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
  SET_MARCA_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
  SET_VERSION_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
  SET_KILOMETRAJE_DEL_VEHICULO_COMPRAMOS_TU_AUTO,
  SET_COMENTARIOS_COMPRAMOS_TU_AUTO,
  SET_AVISO_PRIVACIDAD_COMPRAMOS_TU_AUTO,
  SET_TERMINOS_Y_CONDICIONES_COMPRAMOS_TU_AUTO,
  SET_LEGALES_COMPRAMOS_TU_AUTO,
  SET_URL_HOME_DEALER_COMPRAMOS_TU_AUTO,
  RESET_STATE_COMPRAMOS_TU_AUTO,
} from "../types";

const initialState = {
  nombre: "",
  apellidoPaterno: "",
  telefono: "",
  celular: "",
  email: "",
  ciudad: "",
  estado: "",
  tratamiento: "Sr",
  sexo: "Masculino",
  numeroConcesionaria: "",
  concesionariaPreferida: "",
  anoVehiculo: "",
  modeloVehiculo: "",
  colorVehiculo: "",
  marcaVehiculo: "",
  versionVehiculo: "",
  kilometrajeVehiculo: "",
  descripcion: "",
  avisoPrivacidad: false,
  terminosCondiciones: false,
  legales: false,
  urlHomeDealer: "https://www.audi.com.mx/mx/web/es.html",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TRATAMIENTO:
      return {
        ...state,
        tratamiento: action.payload,
      };
    case SET_SEXO:
      return {
        ...state,
        sexo: action.payload,
      };
    case SET_NOMBRE_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        nombre: action.payload,
      };
    case SET_APELLIDO_PATERNO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        apellidoPaterno: action.payload,
      };
    case SET_ESTADO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        estado: action.payload,
      };
    case SET_CIUDAD_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        ciudad: action.payload,
      };
    case SET_ID_CONCESIONARIO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        numeroConcesionaria: action.payload,
      };
    case SET_CONCESIONARIO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        concesionariaPreferida: action.payload,
      };
    case SET_TELEFONO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        telefono: action.payload,
      };
    case SET_MOVIL_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        celular: action.payload,
      };
    case SET_CORREO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        email: action.payload,
      };
    case SET_ANO_DEL_VEHICULO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        anoVehiculo: action.payload,
      };
    case SET_MODELO_DEL_VEHICULO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        modeloVehiculo: action.payload,
      };
    case SET_COLOR_DEL_VEHICULO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        colorVehiculo: action.payload,
      };
    case SET_MARCA_DEL_VEHICULO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        marcaVehiculo: action.payload,
      };
    case SET_VERSION_DEL_VEHICULO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        versionVehiculo: action.payload,
      };
    case SET_KILOMETRAJE_DEL_VEHICULO_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        kilometrajeVehiculo: action.payload,
      };
    case SET_COMENTARIOS_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        descripcion: action.payload,
      };
    case SET_AVISO_PRIVACIDAD_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        avisoPrivacidad: action.payload,
      };
    case SET_TERMINOS_Y_CONDICIONES_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        terminosCondiciones: action.payload,
      };
    case SET_LEGALES_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        legales: action.payload,
      };
    case SET_URL_HOME_DEALER_COMPRAMOS_TU_AUTO:
      return {
        ...state,
        urlHomeDealer: action.payload,
      };
    case RESET_STATE_COMPRAMOS_TU_AUTO:
      return initialState;
    default:
      return state;
  }
}
